import Navigation from "./components/Navigation";
import BurgerIcon from "./components/BurgerIcon";
import AgntLogo from "../LandingFooter/components/AgntLogo";

type LandingHeaderProps = {
  handleOpen: () => void;
};

const LandingHeader: React.FC<LandingHeaderProps> = ({ handleOpen }) => {
  return (
    <header>
      <div className="relative z-20 max-lg:px-3 px-[2.25vw] mb-[10vw] lg:mb-0">
        <div className="bg-[#F3F3F8] z-20 flex items-center justify-between py-3 px-[1.285vw] max-lg:px-[3.2vw] rounded-28 shadow-custom landing-header">
         <a href="/"> <AgntLogo isHeader={true} /></a>
          <Navigation />
          <BurgerIcon handleClick={handleOpen} />
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
